import { useCallback, useContext } from 'react';
import { AVContext } from '../../context';
function useAVActions() {
    const { av } = useContext(AVContext);
    const join = useCallback((config) => {
        av.join(config);
    }, [av]);
    const publish = useCallback((audioEnabled, videoEnabled) => {
        av.publish(audioEnabled, videoEnabled);
    }, [av]);
    const enableAudio = useCallback((peerId, enabled) => {
        av.enableAudio(peerId, enabled);
    }, [av]);
    const enableVideo = useCallback((peerId, enabled) => {
        av.enableVideo(peerId, enabled);
    }, [av]);
    const captureMediaStreamImage = useCallback((peerId, videoType) => {
        return av.captureMediaStreamImage(peerId, videoType);
    }, [av]);
    const sendMessage = useCallback((type, data, peerId) => {
        av.sendMessage(type, JSON.stringify(data), peerId);
    }, [av]);
    const shareScreen = useCallback((enabled = true) => {
        return av.shareScreen(enabled);
    }, [av]);
    const leave = useCallback(() => {
        av.leave();
    }, [av]);
    const setLogger = useCallback((logger) => {
        av.setLogger(logger);
    }, [av]);
    return {
        join,
        shareScreen,
        enableAudio,
        enableVideo,
        publish,
        sendMessage,
        leave,
        setLogger,
        captureMediaStreamImage,
    };
}
export default useAVActions;
//# sourceMappingURL=useAVActions.js.map